import { Button } from 'components'
import { Enum, AnalyticsUtils } from 'utils'

export default class GetItFixedButton extends React.Component {
  static propTypes = {
    checkType: React.PropTypes.object.isRequired,
    result: React.PropTypes.object.isRequired,
    pageLocation: React.PropTypes.string,
  }

  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired,
  }

  render() {
    if (this.props.checkType.id == Enum.CheckTypes.notfound.id) return null

    //  we are not offering blog services
    if (this.props.checkType.key === "blog") return null

    if (
      this.props.result.get('verdict') ===
        Enum.Verdict.MajorIssuesUserShouldFix ||
      this.props.result.get('verdict') ===
        Enum.Verdict.IssuesUserShouldConsiderFix
    ) {
      const blimponLanding = Enum.GenerateBlimponUrl(
        this.props.checkType.id,
        this.context.currentUser.activeCharge,
        this.props.pageLocation,
      )

      let landing = this.context.currentUser.activeCharge ? blimponLanding : '/plus/upgrade'
      
      return (
        <Button
          label="Get it Fixed"
          buttonType="cta"
          href={landing}
          onTouchTap={() => {
            AnalyticsUtils.getItFixedButtonClicked(
              this.props.checkType.name,
              this.props.pageLocation,
            )
          }}
        />
      )
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/checks/GetItFixedButton.js